require('./ctxGridResizer.style.scss');

class ctxGridResizerDirective {
    constructor($document, $timeout, $localStorage, config) {
        this.restrict = 'A';
        this.require = '^ctxGrid';
        this.$document = $document;
        this.$timeout = $timeout;
        this.$localStorage = $localStorage;
        this.config = config;
    }

    link(scope, element, attrs, ctxGrid) {
        this.$timeout(() => {
            ctxGrid.resizableFlag = true;
            this.tableId = element.parents('.table').attr('id');
        }, 0);

        element.on('mousedown', event => {
            event.preventDefault();
            if (!!ctxGrid.gridColumnsStyleConfig) this.$localStorage[ctxGrid.tableName + '-version-' + this.config.appVersion] = ctxGrid.gridColumnsStyleConfig.columnsWidthMapInPct; this.haveBodyFlag = ctxGrid.$element.find(`#${this.tableId} tbody td:first-child`).width() !== null;
            this.columnIndex = ctxGrid.multiSelect ? parseInt(attrs.index) + 2 : parseInt(attrs.index) + 1;
            this.prevOffsetLeft = element.parent().offset().left;
            this.nextOffsetRight = element.parent().next().offset().left + parseInt(element.parent().next().css('width').split('px')[0]);
            ctxGrid.initialStartPoint = event.pageX;

            this.setInitialHeadValues(ctxGrid, element);

            this.$document.bind('mousemove', event => this.mouseMove(event, element, attrs, ctxGrid));
            this.$document.bind('mouseup', () => this.mouseUp(element, ctxGrid));
        });
    }

    setInitialHeadValues(ctxGrid, element) {
        ctxGrid.initialPrevHeadWidth = this.getPrevHeadWidth(element.parent());
        ctxGrid.initialNextHeadWidth = this.getNextHeadWidth(element.parent().next());

        this.calcPct = Number(ctxGrid.gridColumnsStyleConfig.columnsWidthMapInPct[this.columnIndex - 1].split('%')[0]) + Number(ctxGrid.gridColumnsStyleConfig.columnsWidthMapInPct[this.columnIndex].split('%')[0]);
        this.calcPct = this.roundPct(this.calcPct, 0);

        this.setPrevHeadWidth(element, ctxGrid.initialPrevHeadWidth, ctxGrid, false);
        this.setNextHeadWidth(element, ctxGrid.initialNextHeadWidth, ctxGrid, false);
    }

    mouseMove(event, element, attrs, ctxGrid) {
        const limitSize = 100;
        if (!element.hasClass('visible')) element.addClass('visible');

        if (this.prevOffsetLeft < event.pageX < this.nextOffsetRight) {
            let prevHeadWidth = 0;
            let nextHeadWidth = 0;

            if (event.pageX > ctxGrid.initialStartPoint) {
                const diff = event.pageX - ctxGrid.initialStartPoint;
                prevHeadWidth = ctxGrid.initialPrevHeadWidth + diff;
                nextHeadWidth = ctxGrid.initialNextHeadWidth - diff;
            }
            else if (event.pageX < ctxGrid.initialStartPoint) {
                const diff = ctxGrid.initialStartPoint - event.pageX;
                prevHeadWidth = ctxGrid.initialPrevHeadWidth - diff;
                nextHeadWidth = ctxGrid.initialNextHeadWidth + diff;
            }

            if ((prevHeadWidth < limitSize) || (nextHeadWidth < limitSize)) return;

            this.setPrevHeadWidth(element.parent(), prevHeadWidth, ctxGrid, false);
            this.setNextHeadWidth(element.parent().next(), nextHeadWidth, ctxGrid, false);
            if (this.haveBodyFlag) {
                this.setPrevRowWidth(ctxGrid, prevHeadWidth, false);
                this.setNextRowWidth(ctxGrid, nextHeadWidth, false);
            }

            this.calculateValues(element, ctxGrid, true);
        }
    }

    calculateValues(element, ctxGrid, inPercentage) {
        //header
        const newPrevHeadWidth = this.getPrevHeadWidth(element.parent());
        const newPrevHeadWidthInPct = this.setPrevHeadWidth(element.parent(), newPrevHeadWidth, ctxGrid, inPercentage);
        const newNextHeadWidthInPct = this.roundPct((this.calcPct - newPrevHeadWidthInPct), 0);
        this.setNextHeadWidth(element.parent().next(), newNextHeadWidthInPct, ctxGrid, inPercentage);

        //body
        if (this.haveBodyFlag) {
            this.setPrevRowWidth(ctxGrid, newPrevHeadWidthInPct, inPercentage);
            this.setNextRowWidth(ctxGrid, newNextHeadWidthInPct, inPercentage);
        }
    }

    mouseUp(element, ctxGrid) {
        this.$document.unbind('mousemove');
        this.$document.unbind('mouseup');
        element.removeClass('visible');
        this.calculateValues(element, ctxGrid, true);
    }

    getPrevHeadWidth(element) {
        return parseInt(element.css('width').split('px')[0]);
    }

    getNextHeadWidth(element) {
        return parseInt(element.css('width').split('px')[0]);
    }

    setPrevHeadWidth(element, value, ctxGrid, inPercentage) {
        if (inPercentage) {
            const pct = this.getPercentage(value, ctxGrid.tableWidth);
            element.css('width', pct + '%');
            if (!!ctxGrid.gridColumnsStyleConfig) this.$localStorage[ctxGrid.tableName + '-version-' + this.config.appVersion][this.columnIndex - 1] = pct + '%';
            return pct;
        } else {
            element.css('width', value + 'px');
        }
    }

    setNextHeadWidth(element, value, ctxGrid, inPercentage) {
        if (inPercentage) {
            element.css('width', value + '%');
            if (!!ctxGrid.gridColumnsStyleConfig) this.$localStorage[ctxGrid.tableName + '-version-' + this.config.appVersion][this.columnIndex] = value + '%';
        } else {
            element.css('width', value + 'px');
        }

    }

    getPrevRowWidth(ctxGrid) {
        return parseInt(ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex})`).css('width').split('px')[0]);
    }

    getNextRowWidth(ctxGrid) {
        return parseInt(ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex + 1})`).css('width').split('px')[0]);
    }

    setPrevRowWidth(ctxGrid, value, inPercentage) {
        if (inPercentage) {
            ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex})`).css('width', value + '%');
        } else {
            ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex})`).css('width', value + 'px');
        }
    }

    setNextRowWidth(ctxGrid, value, inPercentage) {
        if (inPercentage) {
            ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex + 1})`).css('width', value + '%');
        } else {
            ctxGrid.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex + 1})`).css('width', value + 'px');
        }
    }

    getPercentage(value, total) {
        const percentage = value * 100 / total;
        return this.roundPct(percentage, 0);
    }

    roundPct(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    static directiveFactory($document, $timeout, $localStorage, config) {
        return new ctxGridResizerDirective($document, $timeout, $localStorage, config);
    }
}

ctxGridResizerDirective.directiveFactory.$inject = ['$document', '$timeout', '$localStorage', 'config'];

module.exports = ctxGridResizerDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxGridResizer/ctxGridResizer.directive.js